export enum CompanyType {
  LoanApplication = 'loanApplication',
  PortfolioCompany = 'portfolioCompany',
}
